const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/actions.ts';
import { ECheckinWorkItem } from '@cistec/common_web/defs/kisim';
import { KeyValuePair } from '@cistec/common_web/defs/generalDefs';
import { Action } from 'redux';
import { DEFAULT_ECHECKIN_WORKITEM_TKEY, makeSelectECheckinItem } from 'App/store/eCheckinItems';
import * as React from 'react';
import { removeEmptyPropertiesFromData } from '@cistec/common_web/modules/CIS4m/utils/data';
import { put, select, take } from 'redux-saga/effects';
import { actionStartCIS4m } from '@cistec/common_web/modules/CIS4m/actions';
import { getConfiguration } from 'App/utils/clientSetupGetRessource';
import {
    actionCreateECheckin,
    actionUpdateECheckin,
    CREATE_ECHECKIN,
    UPDATE_ECHECKIN,
} from 'App/actions/eCheckinItems';

export const ACTION_TYPE_PATAPP_ECHECKIN_PROGRESS_ACTION = 'PATAPP_ECHECKIN_PROGRESS_ACTION';
export const SET_SELECTED_ECHECKIN = 'PATAPP_SELECT_ECHECKIN_WORKITEM_ACTION';

export const ECHECKIN_FORM_ID = 'eCheckin';

export interface IEcheckInProgressAction extends Action {
    percentFinished: number;
}

export function eCheckinProgressAction(progressPercent: number): IEcheckInProgressAction {
    return { percentFinished: progressPercent, type: ACTION_TYPE_PATAPP_ECHECKIN_PROGRESS_ACTION };
}

export const setSelectedFallNrForECheckin = (fallNr?: string, tKey: string = DEFAULT_ECHECKIN_WORKITEM_TKEY) => {
    return { type: SET_SELECTED_ECHECKIN, caseNumber: fallNr, tKey };
};

export interface IselectECheckin extends Action {
    caseNumber: string;
    tKey: string;
}

function* update(eCheckinWorkItem: ECheckinWorkItem, dataObject: KeyValuePair): Generator<any, boolean> {
    yield put(actionUpdateECheckin(eCheckinWorkItem, dataObject));

    // ignoring the following warning:
    // 'yield' expression implicitly results in an 'any' type because its containing generator lacks a return-type annotation.
    // @ts-ignore
    const action = yield take([UPDATE_ECHECKIN.success, UPDATE_ECHECKIN.failure]);
    return action.type === UPDATE_ECHECKIN.success;
}

function* create(fallNr: string | undefined, dataObject: KeyValuePair): Generator<any, boolean> {
    yield put(actionCreateECheckin(fallNr, dataObject));

    // ignoring the following warning:
    // 'yield' expression implicitly results in an 'any' type because its containing generator lacks a return-type annotation.
    // @ts-ignore
    const action = yield take([CREATE_ECHECKIN.success, CREATE_ECHECKIN.failure]);
    return action.type === CREATE_ECHECKIN.success;
}

export const actionStartECheckin = (
    eCheckinInitData: KeyValuePair,
    fallNr?: string,
    tKey: string = DEFAULT_ECHECKIN_WORKITEM_TKEY
) => {
    const configuration = getConfiguration();

    if (!configuration.eCheckin.form) {
        throw new Error('Cannot start eCheckin without an implementation (configuration.eCheckin.form)');
    }

    const renderForm = () => React.createElement(configuration.eCheckin.form!, {});

    const callback = function* (formId: string, dataObject: any) {
        removeEmptyPropertiesFromData(dataObject);

        // cannot use work item variable created outside, because it is not constant
        const eCheckinWorkItem: ECheckinWorkItem = yield select(makeSelectECheckinItem(fallNr, tKey));
        if (eCheckinWorkItem) {
            // @ts-ignore
            return yield update(eCheckinWorkItem, dataObject);
        } else {
            // @ts-ignore
            return yield create(fallNr, dataObject);
        }
    };

    const config = {
        id: ECHECKIN_FORM_ID,
        renderForm,
        dataObject: eCheckinInitData, // can set default values here for startECheckin
        callback,
    };

    return actionStartCIS4m([config]);
};
